import styled from "styled-components";
import { Label } from "@d-lighted/design-system";

export const BackLabel = styled(Label)`
  text-decoration: underline;
  cursor: pointer;
  margin-left: 5px;
`;
